import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.seller}ConfiguredPartner/:id`;

interface DeleteConfiguredPartnerCommandPayload {
  configuredPartnerId: string;
}

async function deleteConfiguredPartnerCommand({
  configuredPartnerId,
}: DeleteConfiguredPartnerCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(':id', configuredPartnerId);

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.DELETE,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default deleteConfiguredPartnerCommand;
